import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

import API_BASE_URL from "../config/api";


function Subjects() {

    /*
    |--------------------------------------------------------------------------
    | Subjects
    |--------------------------------------------------------------------------
    */

    const [subjects, setSubjects] = useState([]);


    /*
    |--------------------------------------------------------------------------
    | Loading
    |--------------------------------------------------------------------------
    */

    const [loading, setLoading] = useState(true);


    /*
    |--------------------------------------------------------------------------
    | Search
    |--------------------------------------------------------------------------
    */

    const [search, setSearch] = useState("");


    /*
    |--------------------------------------------------------------------------
    | Pagination
    |--------------------------------------------------------------------------
    */

    const [currentPage, setCurrentPage] = useState(1);

    const itemsPerPage = 10;


    /*
    |--------------------------------------------------------------------------
    | Fetch Subjects
    |--------------------------------------------------------------------------
    */

    const fetchSubjects = async () => {

        try {

            setLoading(true);


            const response = await fetch(
                `${API_BASE_URL}/admin/subjects`,
                {
                    method: "GET",

                    headers: {
                        "Accept": "application/json"
                    },

                    credentials: "include"
                }
            );


            const data = await response.json();


            console.log(
                "Subjects Response:",
                data
            );


            /*
            |--------------------------------------------------------------------------
            | Success
            |--------------------------------------------------------------------------
            */

            if (
                response.ok &&
                data.success
            ) {

                /*
                |--------------------------------------------------------------
                | Controller returns:
                |
                | subjects: [...]
                |--------------------------------------------------------------
                */

                setSubjects(
                    data.subjects || []
                );

            } else {

                Swal.fire({

                    icon: "error",

                    title: "Unable to Load Subjects",

                    text:
                        data.message ||
                        "Unable to fetch subjects."

                });

            }


        } catch (error) {

            console.error(
                "Fetch Subjects Error:",
                error
            );


            Swal.fire({

                icon: "error",

                title: "Server Error",

                text:
                    "Unable to connect with server."

            });

        } finally {

            setLoading(false);

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Fetch On Page Load
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        fetchSubjects();

    }, []);


    /*
    |--------------------------------------------------------------------------
    | Delete Subject
    |--------------------------------------------------------------------------
    */

    const handleDelete = async (id) => {


        const result =
            await Swal.fire({

                icon: "warning",

                title: "Delete Subject?",

                text:
                    "Are you sure you want to delete this subject?",

                showCancelButton: true,

                confirmButtonText:
                    "Yes, Delete",

                cancelButtonText:
                    "Cancel",

                confirmButtonColor:
                    "#dc3545",

                cancelButtonColor:
                    "#6c757d"

            });


        if (!result.isConfirmed) {

            return;

        }


        try {

            const response = await fetch(

                `${API_BASE_URL}/admin/subjects/${id}`,

                {

                    method: "DELETE",

                    headers: {

                        "Accept":
                            "application/json"

                    },

                    credentials: "include"

                }

            );


            const data =
                await response.json();


            console.log(
                "Delete Subject Response:",
                data
            );


            /*
            |--------------------------------------------------------------------------
            | Delete Success
            |--------------------------------------------------------------------------
            */

            if (
                response.ok &&
                data.success
            ) {


                setSubjects(
                    (previousSubjects) =>
                        previousSubjects.filter(
                            (item) =>
                                item.id !== id
                        )
                );


                await Swal.fire({

                    icon: "success",

                    title: "Deleted!",

                    text:
                        data.message ||
                        "Subject deleted successfully.",

                    timer: 1500,

                    showConfirmButton: false

                });


                return;

            }


            /*
            |--------------------------------------------------------------------------
            | Delete Failed
            |--------------------------------------------------------------------------
            */

            Swal.fire({

                icon: "error",

                title: "Delete Failed",

                text:
                    data.message ||
                    "Unable to delete subject."

            });


        } catch (error) {

            console.error(
                "Delete Subject Error:",
                error
            );


            Swal.fire({

                icon: "error",

                title: "Server Error",

                text:
                    "Unable to connect with server."

            });

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Search Filter
    |--------------------------------------------------------------------------
    */

    const filteredSubjects =
        subjects.filter((item) => {

            const searchText =
                search
                    .toLowerCase()
                    .trim();


            if (!searchText) {

                return true;

            }


            return (

                String(item.id)
                    .toLowerCase()
                    .includes(searchText)

                ||

                String(item.subject_name)
                    .toLowerCase()
                    .includes(searchText)

                ||

                String(item.status)
                    .toLowerCase()
                    .includes(searchText)

            );

        });


    /*
    |--------------------------------------------------------------------------
    | Total Pages
    |--------------------------------------------------------------------------
    */

    const totalPages =
        Math.ceil(
            filteredSubjects.length /
            itemsPerPage
        );


    /*
    |--------------------------------------------------------------------------
    | Current Page Data
    |--------------------------------------------------------------------------
    */

    const startIndex =
        (currentPage - 1) *
        itemsPerPage;


    const endIndex =
        startIndex +
        itemsPerPage;


    const currentSubjects =
        filteredSubjects.slice(
            startIndex,
            endIndex
        );


    /*
    |--------------------------------------------------------------------------
    | Search Change
    |--------------------------------------------------------------------------
    */

    const handleSearch = (e) => {

        setSearch(
            e.target.value
        );


        /*
        |----------------------------------------------------------------------
        | Search करने पर first page
        |----------------------------------------------------------------------
        */

        setCurrentPage(1);

    };


    /*
    |--------------------------------------------------------------------------
    | Previous Page
    |--------------------------------------------------------------------------
    */

    const handlePrevious = () => {

        if (currentPage > 1) {

            setCurrentPage(
                currentPage - 1
            );

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Next Page
    |--------------------------------------------------------------------------
    */

    const handleNext = () => {

        if (currentPage < totalPages) {

            setCurrentPage(
                currentPage + 1
            );

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Page Correction
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        if (
            totalPages > 0 &&
            currentPage > totalPages
        ) {

            setCurrentPage(
                totalPages
            );

        }


        if (
            totalPages === 0 &&
            currentPage !== 1
        ) {

            setCurrentPage(1);

        }

    }, [
        totalPages,
        currentPage
    ]);


    /*
    |--------------------------------------------------------------------------
    | Loading
    |--------------------------------------------------------------------------
    */

    if (loading) {

        return (

            <div className="container-fluid">

                <div
                    className="
                        d-flex
                        justify-content-center
                        align-items-center
                    "
                    style={{
                        minHeight: "400px"
                    }}
                >

                    <div
                        className="spinner-border text-primary"
                        role="status"
                    >

                        <span className="visually-hidden">
                            Loading...
                        </span>

                    </div>

                </div>

            </div>

        );

    }


    /*
    |--------------------------------------------------------------------------
    | JSX
    |--------------------------------------------------------------------------
    */

    return (

        <div className="container-fluid">


            {/* ================================================================
                HEADER
            ================================================================= */}

            <div
                className="
                    d-flex
                    justify-content-between
                    align-items-center
                    mb-4
                "
            >

                <h3 className="mb-0">

                    Subjects

                </h3>


                <Link
                    to="/add-subject"
                    className="btn btn-primary"
                >

                    + Add Subject

                </Link>

            </div>


            {/* ================================================================
                CARD
            ================================================================= */}

            <div className="card shadow-sm">


                {/* ============================================================
                    SEARCH
                ============================================================= */}

                <div className="card-header bg-white">

                    <div className="row">

                        <div className="col-md-5">

                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search Subject..."
                                value={search}
                                onChange={
                                    handleSearch
                                }
                            />

                        </div>

                    </div>

                </div>


                {/* ============================================================
                    TABLE
                ============================================================= */}

                <div
                    className="card-body p-0"
                    style={{
                        maxHeight: "350px",
                        overflowX: "auto",
                        overflowY: "auto"
                    }}
                >

                    <div
                        className="table-responsive"
                        style={{
                            overflowX: "auto"
                        }}
                    >

                        <table
                            className="
                                table
                                table-hover
                                align-middle
                                mb-0
                            "
                        >

                            <thead className="table-light">

                                <tr>

                                    <th>
                                        #
                                    </th>

                                    <th>
                                        Subject
                                    </th>

                                    <th>
                                        Status
                                    </th>

                                    <th
                                        style={{
                                            minWidth: "180px"
                                        }}
                                    >
                                        Action
                                    </th>

                                </tr>

                            </thead>


                            <tbody>

                                {currentSubjects.length > 0 ? (

                                    currentSubjects.map(
                                        (item, index) => (

                                            <tr
                                                key={
                                                    item.id
                                                }
                                            >

                                                {/* # */}

                                                <td>

                                                    {startIndex +
                                                        index +
                                                        1}

                                                </td>


                                                {/* Subject */}

                                                <td>

                                                    <strong>

                                                        {
                                                            item.subject_name
                                                        }

                                                    </strong>

                                                </td>


                                                {/* Status */}

                                                <td>

                                                    {item.status === "Enable" ? (

                                                        <span
                                                            className="
                                                                badge
                                                                bg-success
                                                            "
                                                        >

                                                            Enable

                                                        </span>

                                                    ) : (

                                                        <span
                                                            className="
                                                                badge
                                                                bg-secondary
                                                            "
                                                        >

                                                            Disable

                                                        </span>

                                                    )}

                                                </td>


                                                {/* Action */}

                                                <td>

                                                    <Link
                                                        to={`/edit-subject/${item.id}`}
                                                        className="
                                                            btn
                                                            btn-sm
                                                            btn-warning
                                                            me-2
                                                        "
                                                    >

                                                        Edit

                                                    </Link>


                                                    <button
                                                        type="button"
                                                        className="
                                                            btn
                                                            btn-sm
                                                            btn-danger
                                                        "
                                                        onClick={() =>
                                                            handleDelete(
                                                                item.id
                                                            )
                                                        }
                                                    >

                                                        Delete

                                                    </button>

                                                </td>

                                            </tr>

                                        )

                                    )

                                ) : (

                                    <tr>

                                        <td
                                            colSpan="4"
                                            className="
                                                text-center
                                                py-5
                                                text-muted
                                            "
                                        >

                                            {search

                                                ? "No subjects found for your search."

                                                : "No subjects available."

                                            }

                                        </td>

                                    </tr>

                                )}

                            </tbody>

                        </table>

                    </div>

                </div>


                {/* ============================================================
                    FOOTER
                ============================================================= */}

                <div className="card-footer bg-white">


                    <div
                        className="
                            d-flex
                            justify-content-between
                            align-items-center
                        "
                    >


                        {/* ----------------------------------------------------
                            Showing
                        ----------------------------------------------------- */}

                        <div>

                            <small className="text-muted">

                                {filteredSubjects.length > 0 ? (

                                    <>

                                        Showing{" "}

                                        <strong>
                                            {startIndex + 1}
                                        </strong>

                                        {" "}to{" "}

                                        <strong>
                                            {Math.min(
                                                endIndex,
                                                filteredSubjects.length
                                            )}
                                        </strong>

                                        {" "}of{" "}

                                        <strong>
                                            {filteredSubjects.length}
                                        </strong>

                                        {" "}subjects

                                    </>

                                ) : (

                                    <>

                                        Showing{" "}

                                        <strong>
                                            0
                                        </strong>

                                        {" "}subjects

                                    </>

                                )}

                            </small>

                        </div>


                        {/* ----------------------------------------------------
                            Previous / Next
                        ----------------------------------------------------- */}

                        {totalPages > 1 && (

                            <div
                                className="
                                    d-flex
                                    gap-2
                                "
                            >

                                {/* Previous */}

                                <button
                                    type="button"
                                    className="
                                        btn
                                        btn-sm
                                        btn-outline-primary
                                    "
                                    onClick={
                                        handlePrevious
                                    }
                                    disabled={
                                        currentPage === 1
                                    }
                                >

                                    &laquo; Previous

                                </button>


                                {/* Current Page */}

                                <span
                                    className="
                                        btn
                                        btn-sm
                                        btn-primary
                                    "
                                >

                                    Page{" "}
                                    {currentPage}
                                    {" "}
                                    of{" "}
                                    {totalPages}

                                </span>


                                {/* Next */}

                                <button
                                    type="button"
                                    className="
                                        btn
                                        btn-sm
                                        btn-outline-primary
                                    "
                                    onClick={
                                        handleNext
                                    }
                                    disabled={
                                        currentPage ===
                                        totalPages
                                    }
                                >

                                    Next &raquo;

                                </button>

                            </div>

                        )}

                    </div>

                </div>


            </div>

        </div>

    );

}


export default Subjects;